/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputFiltersSelectItem
 */
export interface OutputFiltersSelectItem {
    /**
     * 
     * @type {string}
     * @memberof OutputFiltersSelectItem
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof OutputFiltersSelectItem
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof OutputFiltersSelectItem
     */
    value: number;
}

/**
 * Check if a given object implements the OutputFiltersSelectItem interface.
 */
export function instanceOfOutputFiltersSelectItem(value: object): boolean {
    if (!('subtitle' in value)) return false;
    if (!('title' in value)) return false;
    if (!('value' in value)) return false;
    return true;
}

export function OutputFiltersSelectItemFromJSON(json: any): OutputFiltersSelectItem {
    return OutputFiltersSelectItemFromJSONTyped(json, false);
}

export function OutputFiltersSelectItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputFiltersSelectItem {
    if (json == null) {
        return json;
    }
    return {
        
        'subtitle': json['subtitle'],
        'title': json['title'],
        'value': json['value'],
    };
}

export function OutputFiltersSelectItemToJSON(value?: OutputFiltersSelectItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subtitle': value['subtitle'],
        'title': value['title'],
        'value': value['value'],
    };
}

